export const environment = {
  production: false,
  apiBaseUrl: '/api',
  auth0Domain: 'terega.eu.auth0.com',
  auth0ClientId: 'ZIQI8OoqXlTAPVGG9XDwZo9IuP73fQe4',
  auth0Audience: ''
};
